import { Injectable } from '@angular/core';
import moment from 'moment';
import { UiBillingControllerService } from 'src/app/cc-api/services';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  private _billingDetails;
  private _isBillingDetailsLoaded: boolean = false;
  private loadingBillingDetails: boolean = false;
  private _growthPlan;
  private _supportPlan;

  constructor(private uiBillingControllerService: UiBillingControllerService) {}

  get billingDetails() {
    return this._billingDetails;
  }
  get isBillingDetailsLoaded() {
    return this._isBillingDetailsLoaded;
  }

  get growthPlan() {
    if (!this._growthPlan) {
      return;
    }
    const trialEnd = this._growthPlan?.trialEnd;
    const planNameMap = {
      TRIALING: 'Growth Plan',
      ACTIVE: 'Growth Plan',
      CANCELED: 'Growth Plan (Canceled)',
    };
    return {
      ...this._growthPlan,
      trialExpiryInDays: trialEnd
        ? moment(trialEnd).diff(moment(), 'days')
        : null,
      trialEndExpiryDisplayDate: trialEnd
        ? moment(trialEnd).format('Do MMM YYYY')
        : null,
      currentPlanName: planNameMap[this._growthPlan?.status],
    };
  }

  get supportPlan() {
    if (!this._supportPlan) {
      return;
    }
    const trialEnd = this._growthPlan?.trialEnd;
    return {
      ...this._supportPlan,
      supportPlanExpiryInDays: trialEnd
        ? moment(trialEnd).diff(moment(), 'days')
        : null,
      supportPlanExpiryDisplayDate: trialEnd
        ? moment(trialEnd).format('Do MMM YYYY')
        : null,
    };
  }

  get showBillingBanner() {
    const trialingStatuses = [
      'TRIALING',
      'PAUSED',
      'PAST_DUE',
      'CANCELED',
      'INCOMPLETE',
    ];
    return trialingStatuses.includes(this?.growthPlan?.status);
  }

  async getBillingDetails() {
    return new Promise((resolve, reject) => {
      this.loadingBillingDetails = true;
      this.uiBillingControllerService.getBillingMetadataUsingGET().subscribe(
        (response) => {
          this._isBillingDetailsLoaded = true;
          this.loadingBillingDetails = false;
          this._billingDetails = response;
          response?.forEach((plan) => {
            if (plan?.planName === 'GROWTH_PLAN') {
              this._growthPlan = plan;
            } else if (plan?.planName === 'SUPPORT_PLAN') {
              this._supportPlan = plan;
            }
          });
          resolve(response);
        },
        (error) => {
          this._isBillingDetailsLoaded = false;
          this.loadingBillingDetails = false;
          reject(error);
        },
      );
    });
  }
}
